// 装扮: the dress-up panel. One big preview you drag left / right to turn the otter all the way round (16 directions;
// it coasts on when let go), standing, walking or running; under it every choice drawn as the otter
// wearing it: 体型, colour presets and swatches (fur, belly, scarf, each its own; a custom colour too, snapped to a
// pixel-art ramp by looks.js), and the accessories by slot (look-model.js: hats and glasses one at a time, the rest
// combine). Changes show here only; 保存 waits for the account/session authority before the office shows it.
import {
  FURS, BELLIES, SCARVES, BODIES, PRESETS, ACCESSORIES, SLOTS, GEO3D, OTTER_DIRS, wear, clash, seedLook, normLook,
  buildSheet, buildFrame, frames16, facing16, facingFrame, furRamp, creamRamp, scarfRamp, coloursOf, snapColour,
  rgb2hex, otterArtReady, bodyColours,
} from '/looks.js';
import { hydrate } from '/icons.js';
import { flags, onFlags } from '/flags.js';
import { bodyOn, BODY_KEYS, CAT_KEYS } from '/look-model.js';
import { t, tr, onLang, translateDom } from '/i18n.js';

const CSS = `
#dress-panel{position:fixed;inset:0;display:none;align-items:center;justify-content:center;background:rgba(20,40,60,.55);z-index:20}
#dress-panel .dr-card{background:#fff8e7;border:3px solid #1b1410;border-radius:18px;width:min(760px,calc(100vw - 16px));max-height:calc(100dvh - 16px);display:flex;flex-direction:column;overflow:hidden;box-sizing:border-box}
#dress-panel button{font:inherit;color:#1b1410;border:2px solid #1b1410;border-radius:999px;background:#fff;padding:4px 14px;cursor:pointer}
#dress-panel button:disabled{opacity:.4;cursor:default}
#dress-panel button.primary{background:#FDD03B}
.dr-head{display:flex;align-items:center;gap:8px;padding:12px 16px 4px}.dr-head b{font-size:18px;flex:1}
#dress-panel .dr-head button{padding:3px 8px;line-height:1}
.dr-main{flex:1;min-height:0;overflow:auto;display:grid;grid-template-columns:236px 1fr;gap:16px;padding:6px 16px 10px;align-items:start}
.dr-stage{position:sticky;top:0;z-index:1;background:#e9d8b4;border-radius:14px;padding:10px;display:flex;flex-direction:column;align-items:center;gap:8px}
#drPv{width:208px;height:208px;image-rendering:pixelated;cursor:grab;touch-action:pan-y;outline:none;border-radius:10px;user-select:none;-webkit-user-select:none}
#drPv:active{cursor:grabbing}#drPv:focus-visible{box-shadow:0 0 0 2px #1b1410}
.dr-hint{font-size:12px;color:#6b5a44;transition:opacity .6s}
.dr-seg{display:flex;border:2px solid #1b1410;border-radius:999px;overflow:hidden;background:#fff}
#dress-panel .dr-seg button{border:0;border-radius:0;padding:3px 12px;background:#fff}
#dress-panel .dr-seg button+button{border-left:2px solid #1b1410}
#dress-panel .dr-seg button.pick{background:#FDD03B}
.dr-opts section{margin:0 0 10px}
.dr-opts h4{margin:4px 0 6px;font-size:13px;color:#4b3a2c;font-weight:700}.dr-opts h4 small{color:#9a8a74;font-weight:400;margin-left:4px}
.dr-grid{display:flex;flex-wrap:wrap;gap:6px}
#drBodies{display:flex;flex-direction:column;gap:6px}
#dress-panel .dr-opt{display:flex;flex-direction:column;align-items:center;padding:2px 2px 3px;border:2px solid transparent;border-radius:12px;background:#e9d8b4;font-size:11px;line-height:1.2;color:#3b2a1c;min-width:64px}
#dress-panel .dr-opt:hover{background:#f3e5c3}
#dress-panel .dr-opt:focus-visible{outline:2px dashed #1b1410;outline-offset:1px}
#dress-panel .dr-dot:focus-visible,#dress-panel .dr-none:focus-visible{outline:2px dashed #1b1410;outline-offset:2px}
#dress-panel .dr-opt.pick{border-color:#1b1410;background:#FDD03B}
.dr-opt canvas{width:56px;height:56px;image-rendering:pixelated;display:block}
.dr-opt.body canvas{width:64px;height:64px}
.dr-sw{display:flex;align-items:center;gap:6px;margin:6px 0;flex-wrap:wrap}.dr-sw>span{width:34px;color:#4b3a2c;font-size:12px}
#dress-panel .dr-dot{width:28px;height:28px;border-radius:50%;border:2px solid rgba(27,20,16,.25);padding:0;position:relative;overflow:hidden}
#dress-panel .dr-dot.pick{border-color:#1b1410;box-shadow:0 0 0 2px #FDD03B}
#dress-panel .dr-none{height:28px;padding:0 12px;border:2px solid rgba(27,20,16,.25);border-radius:999px;background:#fff;font-size:12px;line-height:1}
#dress-panel .dr-none:hover{border-color:rgba(27,20,16,.5)}
#dress-panel .dr-none.pick{border-color:#1b1410;background:#FDD03B}
.dr-custom{display:inline-block;box-sizing:border-box;cursor:pointer}
.dr-custom.empty{background:conic-gradient(#f87171,#facc15,#4ade80,#38bdf8,#a78bfa,#f472b6,#f87171)}
.dr-custom input{position:absolute;inset:0;opacity:0;width:100%;height:100%;border:0;padding:0;cursor:pointer}
.dr-foot{display:flex;gap:8px;align-items:center;padding:10px 16px 14px;border-top:2px dashed rgba(27,20,16,.15)}
.dr-foot .note{flex:1;font-size:12px;color:#857560;text-align:center}
@media (max-width:640px){
 .dr-main{grid-template-columns:1fr;gap:10px;padding:4px 10px 8px}
 .dr-stage{flex-direction:row;flex-wrap:wrap;justify-content:center;padding:6px;gap:4px 10px}
 #drPv{width:144px;height:144px}
 .dr-side{display:flex;flex-direction:column;align-items:center;gap:6px}
 .dr-foot{padding:8px 10px 12px}.dr-foot .note{display:none}.dr-foot .sp{flex:1}
 #dress-panel .dr-opt{min-width:58px}.dr-opt canvas{width:50px;height:50px}.dr-opt.body canvas{width:56px;height:56px}
}`;

const NONE_SCARF = SCARVES.length - 1; // 「无」
const FRONT = facingFrame(0), QUARTER = facing16(2);
const BODY_ORDER = [...BODIES.keys()].filter((b) => b).concat(0); // the new bodies, then the original otter
// 角色 in two rows, never mixed (artin: 「猫猫一排，水獭一排，不要混」): the otters, then the cats
const isCat = (b) => CAT_KEYS.includes(BODY_KEYS[b]);
const BODY_ROWS = [BODY_ORDER.filter((b) => !isCat(b)), BODY_ORDER.filter(isCat)];
const MOTIONS = [['idle', 'dress.motion.idle'], ['walk', 'dress.motion.walk'], ['run', 'dress.motion.run']]; // [motion, catalog key]
const cssRgb = (c) => `rgb(${c.join(',')})`;
const ramp = (r) => `linear-gradient(135deg,${cssRgb(r[0])} 0 30%,${cssRgb(r[1])} 30% 70%,${cssRgb(r[2])} 70%)`;
const near = (list, c) => {
  let best = 0, bd = Infinity;
  list.forEach((x, i) => { if (!x) return; const d = (x[0] - c[0]) ** 2 + (x[1] - c[1]) ** 2 + (x[2] - c[2]) ** 2; if (d < bd) { bd = d; best = i; } });
  return best;
};
const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
/** data-i18n-attrs for HTML: attributes worded by translateDom (public/i18n.js), again on a language change. */
const i18nAttrs = (o) => `data-i18n-attrs='${JSON.stringify(o)}'`;
/** data-i18n for HTML: the element's text, worded the same way. */
const i18n = (key) => `data-i18n="${key}"`;

/** @param o {me: () => peer, lookOf: (peer) => look, send, persist: (look) => Promise, toast, otterImgs, saved?: (look) => void}
 *  @returns {{open: () => void, isOpen: () => boolean}} */
export function initDress(o) {
  let draft = null, hist = [], panel = null, raf = 0, lastScarf = 0, picking = false, saving = false, bodyExplicit = false;
  const view = { deg: 0, vel: 0, drag: null, motion: 'idle', t0: 0, moved: false };
  const $ = (id) => document.getElementById(id);
  // the 3D accessory overlays load with looks.js: anything drawn before they're in is drawn again without them
  otterArtReady.then(() => { thumbs.clear(); sheetKey = ''; render(); });

  // ---- drawing, cached: the preview's sheet per look, and thumbnails per (look, frame)
  let sheet = null, sheetKey = '';
  const thumbs = new Map();
  const frameOf = (look, frame) => {
    const k = JSON.stringify(look) + '|' + frame;
    let c = thumbs.get(k);
    if (!c) { c = buildFrame(o.otterImgs, look, frame); thumbs.set(k, c); if (thumbs.size > 400) thumbs.delete(thumbs.keys().next().value); }
    return c;
  };
  const paint = (cv, src) => { const g = cv.getContext('2d'); g.imageSmoothingEnabled = false; g.clearRect(0, 0, cv.width, cv.height); g.drawImage(src, 0, 0, cv.width, cv.height); };

  // ---- the edits: each one first remembers the look before it (撤销)
  const change = (fn, bodyChoice = false) => { hist.push({ look: structuredClone(draft), bodyExplicit }); if (hist.length > 60) hist.shift(); if (bodyChoice) bodyExplicit = true; fn(draft); draft = normLook(draft); render(); };
  const toggle = (id) => change((d) => { d.acc = d.acc.includes(id) ? d.acc.filter((x) => x !== id) : wear(d.acc, id); });
  const clearSlot = (slot) => change((d) => { d.acc = d.acc.filter((x) => ACCESSORIES.find((a) => a.id === x).slot !== slot); });
  const withAcc = (look, id) => normLook({ ...look, acc: look.acc.includes(id) ? look.acc : wear(look.acc, id) });
  const setTint = (d, kind, hex) => { const t = { ...(d.tint || {}) }; if (hex) t[kind] = hex; else delete t[kind]; d.tint = Object.keys(t).length ? t : undefined; };

  function randomLook() {
    const r = (n) => Math.floor(Math.random() * n), l = seedLook(crypto.randomUUID());
    const bodies = [...BODIES.keys()].filter((b) => bodyOn(b, flags())); l.body = bodies[r(bodies.length)]; // (not one behind a flag that's off here)
    let acc = [];
    const maybe = (p, id) => { if (Math.random() < p) acc = wear(acc, id); };
    const hats = ACCESSORIES.filter((a) => a.slot === 'hat'), faces = ACCESSORIES.filter((a) => a.slot === 'face');
    if (Math.random() < 0.5) acc = wear(acc, hats[r(hats.length)].id);
    if (Math.random() < 0.3) acc = wear(acc, faces[r(faces.length)].id);
    maybe(0.25, 'bowtie'); maybe(0.2, 'phones');
    if (Math.random() < 0.25 && !acc.some((x) => clash(x, 'flower'))) acc = wear(acc, 'flower');
    l.acc = acc;
    if (Math.random() < 0.2) l.tint = { fur: rgb2hex(snapColour('fur', rgb2hex([r(256), r(256), r(256)]))) };
    bodyColours(l, l.body); // 月薪喵 comes in its own colours
    return normLook(l);
  }

  function build() {
    const s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);
    panel = document.createElement('div'); panel.id = 'dress-panel';
    // the words: data-i18n / data-i18n-attrs, worded by translateDom now and again on a language change (public/i18n.js)
    const slotHtml = SLOTS.map((s) => `<section><h4><span ${i18n(s.name)}></span><small ${i18n(s.one ? 'dress.slot.one' : 'dress.slot.many')}></small></h4><div class="dr-grid" data-slot="${s.id}"></div></section>`).join('');
    const sw = (kind, label) => `<div class="dr-sw" data-kind="${kind}"><span ${i18n(label)}></span></div>`;
    panel.innerHTML = `<div class="dr-card" role="dialog" ${i18nAttrs({ 'aria-label': 'dress.title' })}>
      <div class="dr-head"><b ${i18n('dress.title')}></b><button id="drClose" ${i18nAttrs({ title: 'dress.close.tip', 'aria-label': 'dress.close' })}><i data-px="close"></i></button></div>
      <div class="dr-main">
        <div class="dr-stage">
          <canvas id="drPv" width="192" height="192" tabindex="0" ${i18nAttrs({ 'aria-label': 'dress.preview' })}></canvas>
          <div class="dr-side"><div class="dr-hint" id="drHint" ${i18n('dress.hint')}></div>
          <div class="dr-seg" id="drMotion" role="group" ${i18nAttrs({ 'aria-label': 'dress.motion' })}>${MOTIONS.map(([m, n]) => `<button data-m="${m}" ${i18n(n)}></button>`).join('')}</div></div>
        </div>
        <div class="dr-opts">
          <section><h4 ${i18n('dress.bodies')}></h4><div id="drBodies"><div class="dr-grid"></div><div class="dr-grid"></div></div></section>
          <section><h4><span ${i18n('dress.presets')}></span><small ${i18n('dress.presets.tip')}></small></h4><div class="dr-grid" id="drPresets"></div>
            ${sw('fur', 'dress.sw.fur')}${sw('belly', 'dress.sw.belly')}${sw('scarf', 'dress.scarf')}</section>
          ${slotHtml}
        </div>
      </div>
      <div class="dr-foot"><button id="drRandom"><i data-px="dice"></i> <span ${i18n('dress.random')}></span></button><button id="drUndo"><i data-px="undo"></i> <span ${i18n('dress.undo')}></span></button>
        <span class="note" ${i18n('dress.note')}></span><span class="sp"></span><button id="drSave" class="primary"><i data-px="check"></i> <span ${i18n('dress.save')}></span></button></div>
    </div>`;
    translateDom(panel); hydrate(panel); document.body.appendChild(panel);

    // tiles: one button with a canvas per choice; render() redraws them. name: a catalog key (tr: worded again on a language change)
    const tile = (box, cls, name, data, showName = true) => {
      const b = document.createElement('button'); b.className = 'dr-opt ' + cls; tr(b, null, undefined, { title: name, 'aria-label': name });
      Object.assign(b.dataset, data);
      b.innerHTML = `<canvas width="64" height="64"></canvas>${showName ? '<span></span>' : ''}`;
      if (showName) tr(b.querySelector('span'), name);
      box.appendChild(b); return b;
    };
    BODY_ROWS.forEach((row, i) => { for (const body of row) tile($('drBodies').children[i], 'body', BODIES[body].name, { body }, false); }); // 角色: otters, then cats, no names
    PRESETS.forEach((p, i) => tile($('drPresets'), 'preset', p.name, { preset: i }));
    for (const s of SLOTS) {
      const box = panel.querySelector(`[data-slot="${s.id}"]`);
      if (s.one) tile(box, 'none', 'dress.wearNone', { clear: s.id });
      if (s.id === 'neck') tile(box, 'scarf', 'dress.scarf', { scarfOn: 1 });
      for (const a of ACCESSORIES.filter((a) => a.slot === s.id)) tile(box, 'acc', a.name, { acc: a.id });
    }
    // swatches: the palette, then a custom colour (snapped to a ramp)
    for (const [kind, list] of [['fur', FURS.map((f) => furRamp(f))], ['belly', BELLIES.map((b) => creamRamp(b.c))], ['scarf', SCARVES.map((s) => (s.c ? scarfRamp(s.c) : null))]]) {
      const row = panel.querySelector(`.dr-sw[data-kind="${kind}"]`);
      list.forEach((r, i) => {
        // no scarf: a 「无」 chip, not a striped dot (that read as a swim ring)
        const b = document.createElement('button'); b.className = r ? 'dr-dot' : 'dr-none'; b.dataset.kind = kind; b.dataset.i = i;
        const name = (kind === 'fur' ? FURS : kind === 'belly' ? BELLIES : SCARVES)[i].name; tr(b, null, undefined, { title: r ? name : 'dress.noScarf', 'aria-label': r ? name : 'dress.noScarf' });
        if (r) b.style.background = ramp(r); else tr(b, 'dress.none');
        row.appendChild(b);
      });
      const c = document.createElement('label'); c.className = 'dr-dot dr-custom empty'; tr(c, null, undefined, { title: 'dress.custom' }); c.dataset.kind = kind;
      c.innerHTML = `<input type="color" ${i18nAttrs({ 'aria-label': 'dress.custom' })} data-kind="${kind}">`; translateDom(c);
      row.appendChild(c);
    }

    panel.addEventListener('click', (e) => {
      if (saving) return;
      if (e.target === panel) { if (!hist.length) close(); return; } // a tap beside the card doesn't throw changes away
      const b = e.target.closest('button'); if (!b || !draft) return;
      const d = b.dataset;
      if (d.body !== undefined) change((l) => { if (l.body !== +d.body) bodyColours(l, +d.body); l.body = +d.body; }, true); // switching to 月薪喵: its own colours
      else if (d.preset !== undefined) { const p = PRESETS[+d.preset]; change((l) => { l.fur = p.fur; l.belly = p.belly; l.scarf = p.scarf; l.tint = p.tint ? { ...p.tint } : undefined; }); }
      else if (d.clear) clearSlot(d.clear);
      else if (d.scarfOn) change((l) => { if (l.scarf === NONE_SCARF) l.scarf = lastScarf; else { lastScarf = l.scarf; l.scarf = NONE_SCARF; } });
      else if (d.acc) toggle(d.acc);
      else if (d.kind) change((l) => { l[d.kind] = +d.i; setTint(l, d.kind, null); if (d.kind === 'scarf' && +d.i !== NONE_SCARF) lastScarf = +d.i; });
      else if (d.m) { view.motion = d.m; view.t0 = performance.now(); render(); }
    });
    // a custom colour: live while the picker moves (one 撤销 step per pick), snapped as the otter will wear it
    panel.addEventListener('input', (e) => {
      if (saving) return;
      const kind = e.target.dataset?.kind; if (!kind || !draft) return;
      const c = snapColour(kind, e.target.value), hex = rgb2hex(c);
      const set = (l) => {
        setTint(l, kind, hex);
        if (kind === 'fur') l.fur = near(FURS.map((f) => f.fur), c); // the nearest palette entry, for pages from before tints
        else if (kind === 'belly') l.belly = near(BELLIES.map((b) => b.c), c);
        else l.scarf = near(SCARVES.map((s) => s.c), c);
      };
      if (!picking) { picking = true; change(set); } else { set(draft); draft = normLook(draft); render(); }
    });
    panel.addEventListener('change', () => { picking = false; });
    panel.addEventListener('keydown', (e) => {
      e.stopPropagation(); // the deck's arrow keys / WASD walk the otter: not while dressing up
      if (saving) return;
      if (e.key === 'Escape') close();
      else if (e.target.id === 'drPv' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) { view.vel = 0; view.deg += (e.key === 'ArrowRight' ? 1 : -1) * (360 / OTTER_DIRS); e.preventDefault(); }
    });
    panel.addEventListener('keyup', (e) => e.stopPropagation());
    $('drClose').onclick = close;
    $('drUndo').onclick = () => { if (hist.length) { const last = hist.pop(); draft = last.look; bodyExplicit = last.bodyExplicit; render(); } };
    $('drRandom').onclick = () => change((l) => { for (const k of Object.keys(l)) delete l[k]; Object.assign(l, randomLook()); }, true);
    $('drSave').onclick = async () => {
      const me = o.me(); if (!me || !draft) return;
      if (saving) return;
      const look = normLook(draft); saving = true; $('drSave').disabled = true;
      try {
        const saved = await o.persist(look, bodyExplicit);
        if (!saved?.look) throw new Error('look was not saved');
        const current = o.me();
        if (current && current.seed === me.seed) {
          current.look = saved.look; o.saved?.(saved.look); o.send({ t: 'look_sync' });
        }
        saving = false; close();
      } catch { o.toast(t('dress.saveFailed')); }
      finally { saving = false; $('drSave').disabled = false; }
    };
    bindDrag($('drPv'));
  }

  // ---- the preview: drag to turn (with a coast when let go), arrows too; idle / walk / run play in that direction
  function bindDrag(cv) {
    cv.addEventListener('pointerdown', (e) => {
      if (saving) return;
      cv.setPointerCapture(e.pointerId); view.drag = { x: e.clientX, t: e.timeStamp, id: e.pointerId }; view.vel = 0;
    });
    cv.addEventListener('pointermove', (e) => {
      const g = view.drag; if (!g || g.id !== e.pointerId) return;
      const dx = e.clientX - g.x, dt = Math.max(1, e.timeStamp - g.t), k = 360 / (cv.clientWidth * 1.6); // a turn per 1.6 widths
      view.deg += dx * k; view.vel = 0.6 * view.vel + 0.4 * ((dx * k) / dt); g.x = e.clientX; g.t = e.timeStamp;
      if (Math.abs(dx) > 2 && !view.moved) { view.moved = true; $('drHint').style.opacity = '0.45'; }
    });
    const up = (e) => { if (view.drag?.id === e.pointerId) { if (e.timeStamp - view.drag.t > 80) view.vel = 0; view.drag = null; } };
    cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up);
  }
  function framesNow() {
    const N = OTTER_DIRS, d = ((Math.round(view.deg / (360 / N)) % N) + N) % N, m = view.motion;
    return { list: frames16(m, d), ms: GEO3D.anim[m].ms };
  }
  let lastT = 0;
  function tick(t) {
    raf = requestAnimationFrame(tick);
    const dt = Math.min(64, t - (lastT || t)); lastT = t;
    if (!view.drag && view.vel) { view.deg += view.vel * dt; view.vel *= Math.exp(-dt / 420); if (Math.abs(view.vel) < 0.01) view.vel = 0; }
    const cv = $('drPv'); if (!cv || !sheet) return;
    const { list, ms } = framesNow(), f = list[Math.floor((t - view.t0) / ms) % list.length];
    const g = cv.getContext('2d'), S = cv.width / 32;
    g.imageSmoothingEnabled = false; g.clearRect(0, 0, cv.width, cv.height);
    g.fillStyle = 'rgba(60,40,20,.18)'; g.beginPath(); g.ellipse(cv.width / 2, cv.height * 0.86, cv.width * 0.24, cv.height * 0.05, 0, 0, Math.PI * 2); g.fill();
    // walking / running: the floor slides by under the otter, the way it faces
    if (view.motion !== 'idle') {
      const a = (view.deg * Math.PI) / 180, sp = view.motion === 'run' ? 0.09 : 0.04, off = ((t * sp) % 24 + 24) % 24;
      g.fillStyle = 'rgba(60,40,20,.22)';
      for (let i = -3; i <= 3; i++) {
        const along = i * 24 - off, x = cv.width / 2 - Math.sin(a) * along * 1.2, y = cv.height * 0.86 - Math.cos(a) * along * 0.25;
        if (Math.abs(along) < 64) g.fillRect(Math.round(x / S) * S - S, Math.round(y / S) * S, S * 2, S);
      }
    }
    g.drawImage(sheet, (f % 12) * 32, Math.floor(f / 12) * 32, 32, 32, 0, 0, cv.width, cv.height);
  }

  onLang(() => render()); // the accessories' titles (the rest: tr / data-i18n)
  onFlags(() => render()); // the office's flags came (or changed) with the panel open: show / hide the bodies behind one
  function render() {
    if (!panel || !draft) return;
    const key = JSON.stringify(draft);
    if (key !== sheetKey) { sheetKey = key; sheet = buildSheet(o.otterImgs, draft); }
    const pick = (b, on) => { b.classList.toggle('pick', !!on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    for (const b of panel.querySelectorAll('.dr-opt')) {
      const d = b.dataset, cv = b.querySelector('canvas');
      let look = draft, frame = QUARTER, on = false;
      if (d.body !== undefined) b.style.display = bodyOn(+d.body, flags()) ? '' : 'none'; // behind a feature flag that's off here (flags.js)
      if (d.body !== undefined) { look = normLook(draft.body === +d.body ? draft : bodyColours({ ...draft, body: +d.body }, +d.body)); frame = FRONT; on = draft.body === +d.body; } // a body's picture: what picking it gives
      else if (d.preset !== undefined) { const p = PRESETS[+d.preset]; look = normLook({ ...draft, fur: p.fur, belly: p.belly, scarf: p.scarf, tint: p.tint }); frame = FRONT; on = same(coloursOf(look), coloursOf(draft)); }
      else if (d.clear) { look = normLook({ ...draft, acc: draft.acc.filter((x) => ACCESSORIES.find((a) => a.id === x).slot !== d.clear) }); on = !draft.acc.some((x) => ACCESSORIES.find((a) => a.id === x).slot === d.clear); }
      else if (d.scarfOn) { on = draft.scarf !== NONE_SCARF; look = on ? draft : normLook({ ...draft, scarf: lastScarf }); }
      else if (d.acc) {
        on = draft.acc.includes(d.acc); look = withAcc(draft, d.acc);
        const off = draft.acc.filter((x) => clash(x, d.acc)).map((x) => t(ACCESSORIES.find((a) => a.id === x).name));
        const name = t(ACCESSORIES.find((a) => a.id === d.acc).name);
        b.title = off.length && !on ? t('dress.acc.swap', { name, off: off.join(t('dress.sep')) }) : name;
      }
      paint(cv, frameOf(look, frame)); pick(b, on);
    }
    const tint = draft.tint || {};
    for (const b of panel.querySelectorAll('.dr-dot[data-i], .dr-none[data-i]')) pick(b, !tint[b.dataset.kind] && draft[b.dataset.kind] === +b.dataset.i);
    for (const c of panel.querySelectorAll('.dr-custom')) {
      const kind = c.dataset.kind, hex = kind === 'scarf' && draft.scarf === NONE_SCARF ? null : tint[kind];
      c.classList.toggle('empty', !hex); pick(c, !!hex);
      const cols = coloursOf(draft);
      c.style.background = hex ? ramp(kind === 'fur' ? furRamp(cols.fur) : kind === 'belly' ? creamRamp(cols.belly) : scarfRamp(cols.scarf)) : '';
      const input = c.querySelector('input'); if (hex && !picking) input.value = hex;
    }
    for (const b of panel.querySelectorAll('#drMotion button')) pick(b, b.dataset.m === view.motion);
    $('drUndo').disabled = !hist.length;
  }

  function close() { if (saving) return; if (panel) panel.style.display = 'none'; cancelAnimationFrame(raf); raf = 0; draft = null; }
  async function open() {
    const me = o.me(); if (!me) return;
    if (!panel) build();
    draft = normLook(o.lookOf(me)); hist = []; picking = false; bodyExplicit = false; lastScarf = draft.scarf === NONE_SCARF ? 0 : draft.scarf;
    view.deg = 0; view.vel = 0; view.motion = 'idle'; view.t0 = performance.now(); view.moved = false; $('drHint').style.opacity = '1';
    panel.style.display = 'flex'; sheetKey = '';
    render();
    if (!raf) { lastT = 0; raf = requestAnimationFrame(tick); }
    $('drPv').focus({ preventScroll: true });
  }
  return { open, isOpen: () => panel?.style.display === 'flex' };
}
